import { render, staticRenderFns } from "./ktgl-language-selection.vue?vue&type=template&id=e3178f04"
import script from "./ktgl-language-selection.vue?vue&type=script&lang=ts"
export * from "./ktgl-language-selection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports